module.exports = __webpack_public_path__ + "static/media/score_result_4.15ce78f0.png";